/**
 * The welcome screen's requests: signing in and out, joining a world by its code, creating one,
 * leaving. The net layer answers by patching `lobby` in the store.
 */
import type { Game } from '../game';

export type LobbyRequest =
  | { kind: 'login' }
  | { kind: 'register' }
  | { kind: 'logout' }
  | { kind: 'create'; name: string }
  | { kind: 'join'; code: string }
  | { kind: 'leave' };

export interface LobbyState {
  busy: boolean;
  /** An error code for i18n (`refused.<code>`), or null. */
  error: string | null;
}

export const initialLobby = (): LobbyState => ({ busy: false, error: null });

export function requestLobby(game: Game, request: LobbyRequest): void {
  game.events.emit('lobby', request);
}

export function setLobby(game: Game, patch: Partial<LobbyState>): void {
  const s = game.store.get();
  game.store.set({ lobby: { ...s.lobby, ...patch } });
}

/** World codes are the server's ids: lowercase, without confusable letters. People may type them any way. */
export const normalizeCode = (raw: string): string =>
  raw
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');

/** A code as shown: upper case, in two halves. */
export const displayCode = (id: string): string => {
  const upper = id.toUpperCase();
  return upper.length === 8 ? `${upper.slice(0, 4)} ${upper.slice(4)}` : upper;
};
